<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->
    <MainLoader v-if="loading"></MainLoader>
    <div class="custom_card fadeIn">
      <div class="card-header">
        <h4 class="card-title">{{ $t("edit") }}</h4>
      </div>
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateForm">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-12 py-0">
              <div class="upload_input_wrapper">
                <uplode-image
                  :data_src="data.image"
                  @inputChanged="uplodeImg_1"
                  placeHolder="صورة الشهادة"
                ></uplode-image>
              </div>
            </div>
            <div class="col-lg-5 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.alt_image_ar"
                />
                <label for="name_input" class="form-label"
                  >النص البديل للصورة (عربي)</label
                >
              </div>
            </div>
            <div class="col-lg-5 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.alt_image_en"
                />
                <label for="name_input" class="form-label"
                  >النص البديل للصورة (إنجليزي)</label
                >
              </div>
            </div>
            <div class="col-5 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @keypress="isArabic"
                  v-model.trim="data.title_ar"
                />
                <label for="name_input" class="form-label">
                  اسم الشهادة (عربي)
                </label>
              </div>
            </div>
            <div class="col-5 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @keypress="isEnglish"
                  v-model.trim="data.title_en"
                />
                <label for="name_input" class="form-label">
                  اسم الشهادة (إنجليزي)
                </label>
              </div>
            </div>
            <div class="col-8 py-0 mx-auto">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  v-model.trim="data.link"
                />
                <label for="name_input" class="form-label">
                  رابط الشهادة *
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="base-btn">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Update",

  props: ["id"],

  data() {
    return {
      loading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.certificates.title"),
          disabled: false,
          href: "/certificates/show-all",
        },
        {
          text: this.$t("breadcrumb.certificates.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== update_data
      data: {
        link: null,
        image: null,
        title_ar: null,
        title_en: null,
        alt_image_ar: null,
        alt_image_en: null,
      },
    };
  },

  methods: {
    getData() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: `certification/${this.id}`,
      })
        .then((res) => {
          this.data = {
            link: res.data.data.link,
            image: res.data.data.image,
            title_ar: res.data.data.title_ar,
            title_en: res.data.data.title_en,
            alt_image_ar: res.data.data.alt_image_ar,
            alt_image_en: res.data.data.alt_image_en,
          };
          this.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.message,
            position: "bottomRight",
          });
          this.$router.push({ path: "/certificates" });
        });
    },

    uplodeImg_1(obj) {
      this.data.image = obj;
    },

    // Validate Data
    validateForm() {
      this.btnIsLoading = true;

      if (!this.data.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: " صورة الشهادة مطلوبة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      }
      if (!this.data.link) {
        this.$iziToast.error({
          timeout: 2000,
          message: " رابط الشهادة مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      }
      if (!this.data.title_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: " اسم  الشهادة  بالعربي مطلوب    ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      }
      if (!this.data.title_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: " اسم الشهادة إنجليزي  مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },
    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("ar[title]", this.data.title_ar);
      submit_data.append("en[title]", this.data.title_en);
      if (this.data.alt_image_ar) {
        submit_data.append(`ar[alt_image]`, this.data.alt_image_ar);
      }
      if (this.data.alt_image_en) {
        submit_data.append(`en[alt_image]`, this.data.alt_image_en);
      }
      submit_data.append("link", this.data.link);
      submit_data.append("_method", "PUT");
      if (this.data.image?.img_file) {
        submit_data.append("image", this.data.image.img_file);
      }
      this.axios({
        method: "POST",
        url: `certification/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/certificates" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  created() {
    this.getData();
  },
};
</script>
